module.exports = __webpack_public_path__ + "assets/images/icon_red.73ec6803.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/icon_red.png
// module id = 744
// module chunks = 1